<template>
  <div>
    <v-server-table
      ref="HistoryEventsTable"
      :columns="columns"
      :options="options"
    >

    </v-server-table>
  </div>
</template>
<script>
import DatatablesDefaultData from "../../../../../resources/js/DatatablesDefaultData"
export default {
  name: 'HistoryEventsTable',
  props: {
    filter_range: {},
    filter_type:{}
  },
  created () {
    this.setColumns()
  },
  computed: {
    columnsData () {
      return [
        {
          field: 'timestamp',
          label: this.$t('Timestamp')
        },
        {
          field: 'type',
          label: this.$t('EventType')
        },
        {
          field: 'user_name',
          label: 'Usuario'
        },
        {
          field: 'event_description',
          label: this.$t('EventDescription')
        }
      ]
    }
  },
  watch: {
    filter_range: function(){
      this.$refs.HistoryEventsTable.refresh()
    },
    filter_type: function() {
      this.$refs.HistoryEventsTable.refresh()
    }
  },
  data () {
    return {
      columns: [],
      options: {
        requestFunction: async (data) => {
          const res = await this.getData(data)
          return {data:res};
        },
        ...DatatablesDefaultData.options
      }
    }
  },
  methods: {
    setColumns () {
      const headings = {}
      this.columnsData.map((item) => {
        this.columns.push(item.field)
        headings[item.field] = item.label
        if (item.display) {
          this.options.columnsDisplay[item.field] = item.display
        }
      })
      this.options.headings = headings
    },
    async getData(data){
      data.fields = [...this.columns];
      data.type = ''
      if(this.filter_type){
        data.type = this.filter_type.map(t => t.value)
      }
      data.range = this.filter_range || ''
      const params = this.$helpers.setQueryParams(data)
      // console.log({params})
      const res = await axios.get(`/api-admin/history/history-events/${params}`).then(response => {
        const result = response.data.map((event) => {
          return {
            ...event,
            timestamp: moment(event.timestamp).format(
              "YYYY-MM-DD HH:mm:ss"
            )
            };
        });
        return {
          data: result,
          count: response.count
        };
      })
      return res
    }
  }
}
</script>